/**
 * <DateCard
 *	/>
 *
 * - When there is a nesting tr, we use tbody as a row.
 *
 * @parent Preview/index.js
 * @stateless
 */
import React, { PropTypes } from 'react';
import classnames from 'classnames';
import moment from 'moment';
import locale from './locale';
import './DateCard.scss';

class DateCard extends React.Component {
  static propTypes = {
    ticket: PropTypes.object.isRequired,
  }

  constructor(props) {
    super(props);
  }

  componentWillMount() {

  }

  getDateVerbose(start_at) {
    let m = moment(start_at);

    let startDay = m.format('DD');
    let startMonthYearWeekday = m.format(__('MMMM YYYY, ddd', 'dateFormat'));
    let startTime = m.locale('en').format(__('h:mm A'));

    if (startDay.toLowerCase().indexOf('invalid') > -1) {
      startDay = 'N/A';
    }

    if (startMonthYearWeekday.toLowerCase().indexOf('invalid') > -1) {
      startMonthYearWeekday = 'N/A';
    }

    if (startTime.toLowerCase().indexOf('invalid') > -1) {
      startTime = 'N/A';
    }

    return {
      startDay,
      startMonthYearWeekday,
      startTime,
    }

  }

  render() {
    const {
      title,
      start_at,
      ordered_amount,
      price
    } = this.props.ticket;

    const {show_spots_left} = this.props


    let { startDay, startMonthYearWeekday, startTime } = this.getDateVerbose(start_at);

    return (
      <div className='poster-view-date-card'>
        <h4>{__("Registration Start Time", locale)}</h4>
        <h3>{startTime}</h3>
        <h3>{startDay} {startMonthYearWeekday}</h3>
        <h1>{title}</h1>
        <hr />
        <h2 className='course-fee'>{__('Course Fee: ${price}', locale, {price: price})}</h2>
        {show_spots_left == 1 && <h2>
          {__("Total Registered: {numberStr}", locale, {
          numberStr: ordered_amount || 0,
          })}
        </h2>}
      </div>
    )
  }
}

export default DateCard;



// WEBPACK FOOTER //
// ./src/shared/PosterView/DateCard.js